import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { b as inputInvalid, c as inputDisabled, d as inputFocused, i as input, l as label } from './parts.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';
import { d as defineCustomElement$2 } from './custom-popper2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const TextInput = /*@__PURE__*/ proxyCustomElement(class TextInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.isFocused = false;
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.updateInput = (newValue) => {
            const inputElement = this.el.querySelector('input');
            if (inputElement) {
                inputElement.value = newValue || '';
            }
        };
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    get part() {
        if (this.errorText) {
            return inputInvalid;
        }
        if (this.disabled) {
            return inputDisabled;
        }
        if (this.isFocused) {
            return inputFocused;
        }
        return input;
    }
    render() {
        return (h(Host, { key: '9db3238be157235a3fafb0405fb27dff7d2e6f1f' }, h("div", { key: '3ed4b9e3daa689e110e32b9898bcc9f740b5c135', class: "form-group d-flex flex-column" }, h("div", { key: 'd73c83b22711d5665c207d13e901e8aab81b7f7f', class: "d-flex align-items-start gap-2" }, h("label", { key: '28e6b67366ed032ad53df3fc1a24e6f5ebc5a71f', part: label, class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: '26a1e5e1fe37f6dc73cddb17a20d0d1364aa6db5', helpText: this.helpText })), h("input", { key: '5bb865860cfda43f094dda182d59c523360499a6', id: this.name, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onInput: this.handleFormControlInput, onKeyDown: this.keyDownHandler, onPaste: this.keyDownHandler, maxLength: this.maxLength, part: this.part, class: this.errorText ? "form-control is-invalid" : "form-control", type: "text", disabled: this.disabled }), h(FormControlErrorText, { key: '38a7df55036ea06595492911598c096afbd10dd9', errorText: this.errorText, name: this.name }))));
    }
    get el() { return this; }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-text", {
        "name": [8],
        "label": [1],
        "inputHandler": [16, "input-handler"],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "maxLength": [2, "max-length"],
        "keyDownHandler": [16, "key-down-handler"],
        "disabled": [4],
        "isFocused": [32]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-text", "custom-popper", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-text":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, TextInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { TextInput as T, defineCustomElement as d };
